<template>
  <div v-if="status" class="d-flex align-items-center">
    <span class="avisoDanger">{{mensagem}}</span>
    <b-spinner :class="cssClass" variant="danger"></b-spinner>
  </div>
</template>

<script>
import spinnerProcessando from './js'
export default spinnerProcessando
</script>

<style scoped>

</style>
